import React, { useState } from 'react';

import Pagination from 'react-bootstrap/Pagination';
import './PaginationAnything.css';

const PaginationAnything = (props) => {
  const activePage = props.activePage;
  const pageLength = props.pageLength;
  const windowSize = props.windowSize;

  const pages = [...Array(pageLength)].map((x,index)=>{
    return(
      <Pagination.Item key={index+1} active={index+1 === activePage} onClick={(e)=>handleClick(e,index)}>
        {index+1}
      </Pagination.Item>
    )
  });

  const handleClick = (e, index) => {
    e.preventDefault();
    props.handleActivePage(index+1);
  }

  return (
    <Pagination style={{display: "inline-flex"}}>
      <Pagination.First disabled={activePage <= 1} onClick={e=>handleClick(e, 0)} />
      <Pagination.Prev disabled={activePage <= 1} onClick={e=>handleClick(e, activePage - 2)} />
      {pages.filter((item)=>(item.key >= activePage-((activePage-1)%windowSize) ) && (item.key < windowSize + activePage-((activePage-1)%windowSize) ) )}
      <Pagination.Next disabled={activePage >= pages.length} onClick={e=>handleClick(e, activePage)} />
      <Pagination.Last disabled={activePage >= pages.length} onClick={e=>handleClick(e, pages.length-1)} />
    </Pagination>
  )
}

export default PaginationAnything;